import validation from 'lib/utils/validationRules';

const validate = (day, month, year) =>
  !(day.length < 2 || month.length < 2 || year.length < 4);

// eslint-disable-next-line complexity
const dateValidation = (val, options) => {
  if (validation.isNull(val)) {
    return false;
  }

  const dateArray = val.split('.');
  const day = dateArray[0] || '0';
  const month = dateArray[1] || '0';
  const year = dateArray[2] || '0';

  const correctDate = new Date(`${month}/${day}/${year}`);

  if (!validate(day, month, year) || !correctDate.getFullYear()) {
    return false;
  }

  const today = new Date();
  const nowYear = today.getFullYear();
  const nowMonth = today.getMonth() + 1;
  const nowDay = today.getDate();

  const birth = correctDate;
  const birthYear = birth.getFullYear();
  const birthMonth = birth.getMonth() + 1;
  const birthDay = birth.getDate() - 1;

  let age = nowYear - birthYear;
  const ageMonth = nowMonth - birthMonth;
  const ageDay = nowDay - birthDay;

  if (ageMonth < 0 && age <= 0) {
    return false;
  }

  if (age < 0 && (ageMonth > 0 || ageDay > 0)) {
    return false;
  }

  if (age > options.max) {
    return false;
  }

  if (ageMonth < 0 || (ageMonth === 0 && ageDay < 0)) {
    age = parseInt(age) - 1;
  }

  if (
    (age === options.min && ageMonth <= 0 && ageDay <= 0) ||
    age < options.min
  ) {
    return false;
  }

  return true;
};

export default dateValidation;
